import { useState } from "react";

// Pagination
export default function Pagination({ totalPages = 5 }) {
    const [current, setCurrent] = useState(2);

    const handlePrev = () => setCurrent((p) => Math.max(1, p - 1));
    const handleNext = () => setCurrent((p) => Math.min(totalPages, p + 1));

    return (
        <div className="text-black d-flex justify-content-center align-items-center gap-2 gap-lg-3 mt-5">
            {/* Previous Arrow */}
            <button className="btn bg-primary bg-opacity-25 border-0 rounded-circle d-flex align-items-center justify-content-center text-lg text-primary p-0"
                style={{ minWidth: 38, width: 38, height: 38 }}
                onClick={handlePrev}
                disabled={current === 1}
                aria-label="Previous page"
            >
                <i className="bi bi-arrow-left" />
            </button>

            {/* Page Numbers */}
            <div className="d-flex gap-2">
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                    <button
                        key={page}
                        onClick={() => setCurrent(page)}
                        className={`btn btn-sm d-flex align-items-center justify-content-center rounded-circle p-0`}
                        style={{
                            minWidth: 38,
                            width: 38,
                            height: 38,
                            backgroundColor: current === page ? "var(--bs-primary)" : "transparent",
                            color: current === page ? "var(--bs-white)" : "#374151",
                            border: current === page ? "none" : "1px solid #E5E7EB",
                        }}
                        aria-current={current === page ? "page" : undefined}
                    >
                        {String(page).padStart(2, "0")}
                    </button>
                ))}
            </div>

            {/* Next Arrow */}
            <button className="btn bg-primary bg-opacity-25 border-0 rounded-circle d-flex align-items-center justify-content-center text-lg text-primary p-0"
                style={{
                    minWidth: 38,
                    width: 38,
                    height: 38,
                }}
                onClick={handleNext}
                disabled={current === totalPages}
                aria-label="Next page"
            >
                <i className="bi bi-arrow-right" />
            </button>
        </div>
    );
}